import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { WalletService } from '../../services/wallet.service';
import {
  fetchPartnerWalletList,
  loadedPartnerWalletList,
  failedPartnerWalletList,
  updatePartnerWalletListFilter,
} from './partner-wallet-list.actions';
import { selectPartnerWalletListFilter } from './partner-wallet-list.selector';

@Injectable()
export class PartnerWalletListEffect {
  loadPartnerWalletList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchPartnerWalletList),
      switchMap(({ filter }) =>
        this.walletService.getPartnerWalletList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedPartnerWalletList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedPartnerWalletList();
            }
          }),
          catchError(() => of(failedPartnerWalletList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updatePartnerWalletListFilter),
      concatLatestFrom(() => this.store.select(selectPartnerWalletListFilter)),
      switchMap(([action, prevFilter]) =>
        of(
          fetchPartnerWalletList({
            filter: { ...prevFilter, ...action.filter },
          })
        )
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly walletService: WalletService
  ) {}
}
